import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import * as CreDtos from "../CRE.dtos";
import * as Config from '../configuration/consts';
import { forumApi } from "../services/forum";

import {
    ADD_REMOVE_POST_TAG_REQUEST,
    FOLLOW_POST_REQUEST,
    ForumAction,
    GET_FORUM_DATA_REQUEST,
    GET_FORUM_LIST_REQUEST,
    GET_FORUM_REQUEST,
    GET_FORUM_UPDATE_REQUEST,
    LOAD_POST_REQUEST,
    followPostFailure,
    followPostSuccess,
    getForumFailure,
    getForumListFailure,
    getForumListSuccess,
    getForumRequest,
    getForumSuccess,
    getForumUpdateFailure,
    getForumUpdateSuccess,
    loadPostSuccess,
    savePostTagFailure,
    savePostTagSuccess,

    SAVE_FORUM_REQUEST,
    SAVE_POST_REACTION_REQUEST,
    SAVE_POST_REQUEST,
    SAVE_TAG_REQUEST,
    SEARCH_POST_REQUEST,
    SEARCH_REQUEST,
    SUBSCRIBE_REQUEST,
    changeActiveTab,
    saveForumFailure,
    saveForumSuccess,
    savePostFailure,
    savePostReactionSuccess,
    savePostSuccess,
    saveTagFailure,
    saveTagSuccess,
    searchFailure,
    searchPostFailure,
    searchPostSuccess,
    searchSuccess,
    subscribeForumSuccess
} from "../actions/forum.actions";


export const getForumDataEpic = action$ =>
    action$
        .ofType(GET_FORUM_DATA_REQUEST)
        .mergeMap((action: ForumAction) =>
            forumApi
                .getForum(action.id, action.summary)
                .mergeMap(response => {
                    return concat$(Observable.of(getForumSuccess(response.forum)))
                })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(getForumFailure(error.responseStatus))
                )
        );

export const getForumEpic = action$ =>
    action$
        .ofType(GET_FORUM_REQUEST)
        .mergeMap((action: ForumAction) =>
            forumApi
                .getForum(action.id, action.summary)
                .mergeMap(response => {
                    var tab = response.forum.isResourceTabDefault ? Config.SHOW_RESOURCES : Config.SHOW_FORUM;
                    const anchor = location && location.hash ? location.hash.replace('#', '') : undefined;
                    switch (anchor) {
                        case "notifications":
                            tab = Config.SHOW_NOTIFICATIONS;
                            break;
                        case "profile":
                            tab = Config.SHOW_PROFILE;
                            break;
                        case "resources":
                            tab = Config.SHOW_RESOURCES;
                            break;
                    }
                    return concat$(Observable.of(getForumSuccess(response.forum)), Observable.of(changeActiveTab(tab)))
                })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(getForumFailure(error.responseStatus))
                )
        );

export const getForumUpdateEpic = action$ =>
    action$
        .ofType(GET_FORUM_UPDATE_REQUEST)
        .mergeMap((action: ForumAction) =>
            forumApi
                .getForumUpdate(action.id, action.email)
                .map(response =>
                    getForumUpdateSuccess(response.forum)
                )
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(getForumUpdateFailure(error.responseStatus))
                )
        );

export const getForumsEpic = action$ =>
    action$
        .ofType(GET_FORUM_LIST_REQUEST)
        .mergeMap((action: ForumAction) =>
            forumApi
                .getForums(action.email)
                .mergeMap(response => {

                    var action = response.forums.length == 1 ? Observable.of(getForumRequest(response.forums[0].id, false)) : Observable.of(changeActiveTab("SHOW_BOARDS"));

                    return concat$(Observable.of(getForumListSuccess( response.forums ))
                        , action) })

                .catch((error: CreDtos.ForumListResponse) =>
                    Observable.of(getForumListFailure(error.responseStatus))
                )
    );

export const saveForumPostReactionEpic = action$ =>
    action$
        .ofType(SAVE_POST_REACTION_REQUEST)
        .mergeMap((action: ForumAction) =>
            forumApi
                .savePostReaction(action.id, action.forumMemberId, action.forumPostId)
                .map(response => savePostReactionSuccess(response))
                .catch((error: CreDtos.ForumPostResponse) =>
                    Observable.of(savePostFailure(error.responseStatus))
                )
        );

export const subscribeEpic = action$ =>
    action$
        .ofType(SUBSCRIBE_REQUEST)
        .mergeMap((action: ForumAction) =>
            forumApi
                .subscribe(action.id)
                .map(response => subscribeForumSuccess(response))
                .catch((error: CreDtos.SubscribeResponse) =>
                    Observable.of(saveTagFailure(error.responseStatus))
                )
        );

export const saveTagEpic = action$ =>
    action$
        .ofType(SAVE_TAG_REQUEST)
        .mergeMap((action: ForumAction) =>
            forumApi
                .saveTag(action.id, action.tag)
                .map(response => saveTagSuccess(response))
                .catch((error: CreDtos.ForumTagResponse) =>
                    Observable.of(saveTagFailure(error.responseStatus))
                )
        );

export const loadPostEpic = action$ =>
    action$
        .ofType(LOAD_POST_REQUEST)
        .mergeMap((action: ForumAction) =>
            forumApi
                .loadPost(action.id, action.forumPostId)
                .mergeMap(response => { return concat$(Observable.of(loadPostSuccess(response)), Observable.of(changeActiveTab(Config.SHOW_FORUM))) })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(savePostFailure(error.responseStatus))
                )
        );

export const savePostEpic = action$ =>
    action$
        .ofType(SAVE_POST_REQUEST)
        .mergeMap(action =>
            forumApi
                .savePost(action.id, action.post, action.tags)
                .map(response => {
                    return savePostSuccess(response);
                })
                .catch(error =>
                    Observable.of(savePostFailure(error.responseStatus))
                )
        );

export const saveForumEpic = action$ =>
    action$
        .ofType(SAVE_FORUM_REQUEST)
        .mergeMap(action =>
            forumApi
                .saveForum(action.forum)
                .map(response => saveForumSuccess(response))
                .catch(error =>
                    Observable.of(saveForumFailure(error.responseStatus))
                )
        );

export const followPostEpic = action$ =>
    action$
        .ofType(FOLLOW_POST_REQUEST)
        .mergeMap(action =>
            forumApi
                .followPost(action.postId, action.subscribed)
                .map(response => followPostSuccess(response))
                .catch(error =>
                    Observable.of(followPostFailure(error.responseStatus))
                )
        );

export const savePostTagEpic = action$ =>
    action$
        .ofType(ADD_REMOVE_POST_TAG_REQUEST)
        .mergeMap(action =>
            forumApi
                .savePostTag(action.tagId, action.postId)
                .map(response => savePostTagSuccess(response))
                .catch(error =>
                    Observable.of(savePostTagFailure(error.responseStatus))
                )
        );

export const searchEpic = action$ =>
    action$
        .ofType(SEARCH_REQUEST)
        .mergeMap(action =>
            forumApi
                .searchBoards(action.email, action.term)
                .map(response => searchSuccess(response))
                .catch(error =>
                    Observable.of(searchFailure(error.responseStatus))
                )
        );

export const searchPostEpic = action$ =>
    action$
        .ofType(SEARCH_POST_REQUEST)
        .mergeMap(action =>
            forumApi
                .searchPosts(action.id, action.term)
                .map(response => searchPostSuccess(response))
                .catch(error =>
                    Observable.of(searchPostFailure(error.responseStatus))
                )
        );



// WEBPACK FOOTER //
// ./src/epics/forum.epic.ts